import { action, atom } from '@reatom/framework'

import { AsyncStateN, Result } from '@blade/std-lib'
import { fetchCurrencyRequestAction } from '@root/entities/currency'
import { currencyRegistry } from '@root/entities/currency/atoms'
import { Network, selectedNetworkAtom } from '@root/entities/network'
import { type Error } from '@root/shared'

import type { CurrencyModel } from '@root/entities/currency'

export const reatomSearchToken = () => {
  const searchStateAtom = atom(
    AsyncStateN.notInitiated<Error.UnknownError, CurrencyModel>(),
    'searchStateAtom',
  )
  const searchQueryAtom = atom('', 'searchQueryAtom')

  const setQueryAction = action((ctx, query: string) => {
    searchQueryAtom(ctx, query)
    searchTokenAction(ctx)
  }, 'setQueryAction')

  const searchTokenAction = action(async (ctx) => {
    searchStateAtom(ctx, AsyncStateN.notInitiated())

    const query = ctx.get(searchQueryAtom)
    const network = ctx.get(selectedNetworkAtom)

    const isValid = Network.validateAddress(network)(query)
    if (!isValid) {
      return
    }

    searchStateAtom(ctx, AsyncStateN.loading())

    const result = await ctx.schedule(() =>
      fetchCurrencyRequestAction(ctx, { address: query, network: network }),
    )

    const mappedResult = result.pipe(
      Result.map((it) => currencyRegistry.resolveFromTokenMeta(ctx, it)),
    )

    searchStateAtom(ctx, AsyncStateN.fromResult(mappedResult))
  }, 'searchTokenAction')

  return {
    searchTokenAction,
    searchStateAtom,
    searchQueryAtom,
    setQueryAction,
  }
}
